module.exports = __webpack_public_path__ + "static/media/Warranty.73f6c66d.svg";